import { IPaymentSend } from 'src/types/payment';
import { PaymentFormData } from 'src/screens/General/screens/Payments/components/PaymentForm';
import { changeToZeroMoment } from './timeHelpers';

const groupPayment = (dataForm: Partial<PaymentFormData>): Partial<IPaymentSend> => {
    const { amount, paymentCredits, paymentInvoices, caseType, paymentDate, ...data } = dataForm;
    const dataSend: Partial<IPaymentSend> = { ...data };

    if (amount) {
        dataSend.amount = parseFloat(`${amount}`);
    }

    if (paymentDate) {
        dataSend.paymentDate = changeToZeroMoment(paymentDate, 'YYYY-MM-DD');
    }
    if (caseType) {
        dataSend.caseType = caseType.value;
    }
    const arrCredits: any = [];
    if (paymentCredits) {
        paymentCredits.forEach((it: any) => {
            const { id, caseNumber, ...dataIt } = it;
            let caNum = 'newNumber';
            if (caseNumber) {
                caNum = caseNumber.value;
            }
            const itTo = {
                comment: dataIt?.comment ? dataIt.comment : '',
                status: +dataIt.status,
                paymentCreditId: id,
                caseNumber: caNum,
                amount: parseFloat(`${it.amount}`),
            };
            arrCredits.unshift(itTo);
        });
    }
    dataSend.paymentCredits = arrCredits;
    const arrInvoices: any = [];
    if (paymentInvoices) {
        Object.keys(paymentInvoices).forEach((k: any) => {
            const am = paymentInvoices[k]['remainingAmount'];
            if (paymentInvoices[k]['action']) {
                const itTo = { invoice: k, amount: parseFloat(`${am}`) };
                arrInvoices.unshift(itTo);
            }
        });
    }
    dataSend.paymentInvoices = arrInvoices;
    return dataSend;
};
export { groupPayment };
